// This file is auto-generated by dibs-icons script
import { type FC } from 'react';

type Recognition48FilledProps = {
    dataTn?: string;
    role?: 'img';
    ariaLabel?: string;
    ariaLabelledby?: string;
};

const Recognition48Filled: FC<Recognition48FilledProps> = props => {
    return (
        <svg
            style={{ display: 'block' }}
            data-tn={props.dataTn}
            role={props.role}
            aria-label={props.ariaLabel}
            aria-labelledby={props.ariaLabelledby}
            width="48"
            height="48"
        >
            <path
                d="M23.999 2.984c8.781 0 15.9 7.119 15.9 15.9 0 3.833-1.357 7.35-3.616 10.095l5.259 9.108-7.9 1.083-4.888 6.3-4.755-8.234-4.754 8.234-4.89-6.3-7.898-1.083 5.258-9.108A15.836 15.836 0 0 1 8.1 18.884c0-8.78 7.118-15.9 15.899-15.9ZM11.286 35.72l4.69.644 2.902 3.739 3.143-5.443a15.826 15.826 0 0 1-8.109-3.488l-2.626 4.548Zm22.8-4.548a15.826 15.826 0 0 1-8.11 3.488l3.144 5.443 2.902-3.74 4.69-.643-2.626-4.548Zm-12.25-9.786-4.01-4.01-2.12 2.122 6.13 6.13L31.875 15.59l-2.121-2.12-7.918 7.917Z"
                fillRule="evenodd"
                clipRule="evenodd"
            />
        </svg>
    );
};

export default Recognition48Filled;
